module.exports = __webpack_public_path__ + "static/media/delete.92662628.svg";